var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "col" },
    [
      _vm.header.visible
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-10 d-flex justify-content-start align-items-center"
              },
              [
                _c("i", { class: _vm.header.iconClass }),
                _c("strong", [_vm._v(_vm._s(_vm.header.title))])
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-2 d-flex justify-content-end align-items-center"
              },
              [
                _c("action-button", {
                  staticClass: "outline-dark-gray",
                  attrs: {
                    disabled: false,
                    i: _vm.allExpanded
                      ? "fal fa-compress-arrows-alt"
                      : "fal fa-expand-alt",
                    text: _vm.allExpanded ? "Colapsar Todo" : "Expandir Todo"
                  },
                  on: { click: _vm.toggleExpandCollapse }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _c(
        "custom-collapse",
        { attrs: { id: "question-sections-collapse" } },
        _vm._l(_vm.sections, function(item, key) {
          return _c(
            "custom-collapse-item",
            {
              key: `section-collapse-item-${key + 1}`,
              ref: `section-collapse-item-${key + 1}`,
              refInFor: true,
              staticClass: "my-3 collapse-item section bg-gray",
              class: { "rounded invalid": item.valid === false },
              attrs: {
                id: `section-collapse-item-${key + 1}`,
                "auto-expand-collapse-enabled": false,
                expanded: item.expanded,
                "expanded-icon": "fas fa-chevron-circle-right color-gray-7",
                "minimized-icon": "fas fa-chevron-circle-down color-green",
                "parent-id": "question-sections-collapse",
                "read-only-icon": "fas fa-plus-circle color-gray-2",
                title: item.name
              },
              on: {
                expandButtonClick: function($event) {
                  return _vm.expand(item, key)
                }
              }
            },
            [
              item.id == 130
                ? _c(
                    "div",
                    [
                      _c("locality-form", {
                        attrs: {
                          "is-preview": _vm.isPreview,
                          "is-read-only": true
                        },
                        model: {
                          value: item.location,
                          callback: function($$v) {
                            _vm.$set(item, "location", $$v)
                          },
                          expression: "item.location"
                        }
                      })
                    ],
                    1
                  )
                : _c("questions", {
                    attrs: {
                      "has-divider": "",
                      "is-preview": _vm.isPreview,
                      "is-read-only": _vm.isReadOnly,
                      value: item.questions
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "selected-answer-questions",
                          fn: function({ questions }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "px-4" },
                                [
                                  _c("questions", {
                                    attrs: {
                                      "is-read-only": _vm.isReadOnly,
                                      value: questions
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }